import { css } from '@emotion/react';
import { theme } from 'global';

// ─── Shared layout ────────────────────────────────────────────────────────────

export const container = css`
  min-height: calc(100vh - 64px);
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const header = css`
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 108px;
  overflow: hidden;
  flex-shrink: 0;

  @media screen and (max-width: ${theme.breaks.sm}px) {
    padding: 0 24px;
  }
`;

export const content = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: 1280px;
  padding: 48px 24px 40px;

  @media screen and (max-width: ${theme.breaks.md}px) {
    padding: 40px 16px 24px;
  }
`;

export const card = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  background: ${theme.colors.neutral[0]};
  border: 1px solid ${theme.colors.neutral[100]};
  border-radius: 12px;
  padding: 40px;
  width: 630px;
  max-width: 100%;

  @media screen and (max-width: ${theme.breaks.md}px) {
    padding: 24px;
  }
`;

export const innerBox = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

// ─── Step 1: logo lockup ──────────────────────────────────────────────────────

export const logoRow = css`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 12px 0;
  overflow: hidden;

  @media screen and (max-width: ${theme.breaks.md}px) {
    padding: 8px 0;
  }
`;

// ─── Shared text styles ───────────────────────────────────────────────────────

export const cardTitle = css`
  align-self: stretch;
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.secondary};
  margin: 0;
`;

export const cardBody = css`
  align-self: stretch;
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.neutral[600]};
  margin: 0;
`;

export const buttonWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const primaryButton = css`
  display: flex;
  padding: 14px 24px 15px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${theme.colors.primary.dark};

  &:hover {
    background: ${theme.colors.primary.dark};
  }
`;

export const secondaryText = css`
  align-self: stretch;
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.neutral[600]};
  margin: 0;
`;

export const secondaryLink = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.primary.medium};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

// ─── Step 1: text content block ───────────────────────────────────────────────

export const textContent = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// ─── Check circle icon ────────────────────────────────────────────────────────

export const checkCircleWrapper = css`
  position: relative;
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
`;

export const checkCircleInner = css`
  position: absolute;
  inset: 8.33%;
`;

export const checkCircleImage = css`
  position: absolute;
  display: block;
  max-width: none;
  width: 100%;
  height: 100%;
`;

// ─── Step 2: USP list ─────────────────────────────────────────────────────────

export const uspList = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const uspItem = css`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const uspText = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.neutral[600]};
  margin: 0;
  flex: 1 0 0;
`;
